import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import styled from '@emotion/styled'

interface CenteredCircularProgresProps {
  loading: boolean
  size?: number
  position?: 'absolute' | 'relative'
}

type StyledDivProps = Pick<CenteredCircularProgresProps, 'position'>

const CenteredCircularProgressDiv = styled('div')<StyledDivProps>`
  display: flex;
  position: ${({ position }) => position ?? 'absolute'};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
`

const CenteredCircularProgress: React.FC<CenteredCircularProgresProps> = ({ loading, size = 50, position = 'relative' }) => {
  if (!loading) return null
  const spinner = (
    <CenteredCircularProgressDiv position={position}>
      <CircularProgress size={size} />
    </CenteredCircularProgressDiv>
  )
  return position === 'absolute' ? spinner : <div style={{ position }}>{spinner}</div>
}

export default CenteredCircularProgress
